<script setup>
import { useScrollbarFlutuante } from '@/composables/useScrollbarFlutuante';

const { visivel, arrastando, temScroll, estiloThumb, mostrar, iniciarArraste } = useScrollbarFlutuante();
</script>

<template>
    <div v-if="temScroll" class="scrollbar-flutuante fixed top-0 right-0 h-screen"
        :class="{ 'scrollbar-flutuante--visivel': visivel || arrastando }">
        <div class="scrollbar-flutuante__thumb absolute border-round-3xl" :style="estiloThumb"
            @pointerenter="mostrar" @pointerdown="iniciarArraste"></div>
    </div>
</template>

<style scoped>
.scrollbar-flutuante {
    width: 12px;
    z-index: 1200;
    opacity: 0;
    background: transparent;
    pointer-events: none;
    transition: opacity 0.4s ease;
}

.scrollbar-flutuante--visivel {
    opacity: 1;
}

.scrollbar-flutuante--visivel .scrollbar-flutuante__thumb {
    pointer-events: auto;
}

.scrollbar-flutuante__thumb {
    top: 0;
    right: 4px;
    width: 4px;
    background: rgba(140, 140, 140, 0.6);
    cursor: pointer;
    transition: width 0.15s ease, background-color 0.15s ease;
}

.scrollbar-flutuante__thumb:hover,
.scrollbar-flutuante__thumb:active {
    width: 6px;
    background: rgba(120, 120, 120, 0.8);
}
</style>
